import React, { useState } from 'react';

import CustomDialog from '../dialogs/CustomDialog';
import ShowDownloadFormButton from '../../misc/ShowDownloadFormButton';
import AccountVideoDownloadForm from './AccountVideoDownloadForm';

const AccountVideoDownload = (props) => {

  const [dialogOpen, setDialogOpen] = useState(false);

  const closeDialog = () => {
    setDialogOpen(false);
  };

  const openDialog = () => {
    setDialogOpen(true);
  };

  return (
    <div className="row account-event-video-download">
      <div className="col-xs-16 col-sm-6 col-sm-offset-8">
        <ShowDownloadFormButton fullWidth={true} onShowFormButtonClick={openDialog}/>
      </div>
      <CustomDialog open={dialogOpen} onRequestClose={closeDialog}>
        <AccountVideoDownloadForm {...props} />
      </CustomDialog>
    </div>
  );
}

export default AccountVideoDownload;